import { render } from "./SmallButton.vue?vue&type=template&id=7ce5b192&ts=true"
import script from "./SmallButton.vue?vue&type=script&lang=ts"
export * from "./SmallButton.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__